define('ordersDetailPriceV2View',[
  'app',
  'module',
  'marionette',
  'jquery',
  'bootbox',
  'underscore',
  'ordersDetailPriceV2PricesView',
  'ordersDetailPriceV2PrintPricesView',
  'template!ordersDetailPriceV2View',
  'entities/caccounts',
  'entities/orders'
], function (
  App,
  module, 
  Marionette,
  $,
  bootbox,
  _,
  PricesView,
  PrintView,
  Tpl
) {
  'use strict';

  module.exports = Marionette.LayoutView.extend({
    template: Tpl,
    className: 'order-detail-price-view',

    regions: {
      priceRegion: '.price-region',
      printPriceRegion: '.print-price-region'
    },

    ui: {
      loading: '.loading'
    },

    onShow: function() {
      this.listenTo(this.model.get('order'), 'change', _.bind(function (model) {
        if (model.hasChanged('quantity'))
          this.renderContent();
        if (model.hasChanged('price'))
          this.renderContent();
      }, this));

      this.listenTo(this, 'get-price-for-order', _.bind(this.renderContent, this));
    },
    
    onRender: function() {
      this.renderContent();
    },

    renderContent: function () {
      this.renderLoading(true);

      $.when(App.request('caccount:get-factors')).done(_.bind(function (factorsV2) {
        $.when(App.request('caccount:get-factors-by-supplier-id', this.model.get('manufacturerId')))
          .done(_.bind(function (factorsV2Supplier) {
            if (factorsV2Supplier) {
              factorsV2 = factorsV2Supplier;
            }
            this.model.get('order').getPrice(true, true).done(_.bind(function (currentPrices) {
              this.model.get('order').getPrice(true, false).done(_.bind(function (currentRsPrices) {
                this.model.get('order').getPrice(false, true).done(_.bind(function (prices) {
                  this.model.get('order').getPrice(false, false).done(_.bind(function (rsPrices) {
                    this.renderLoading(false);

                    if (factorsV2Supplier)
                      factorsV2 = factorsV2Supplier;
          
                    this.pricesView = new PricesView({
                      model: this.model.get('order'),
                      factorsV2: factorsV2,
                      currentPrices: currentPrices,
                      currentRsPrices: currentRsPrices,
                      prices: prices,
                      rsPrices: rsPrices,
                      product: this.model.get('product'),
                      test: 'sdfsdf'
                    });
                    this.pricesView.listenTo(this.pricesView, 'get-price-for-order', _.bind(this.renderContent, this));
                    this.pricesView.listenTo(this.pricesView, 'show-loading', _.bind(this.renderLoading, this));
                    this.pricesView.listenTo(this.pricesView, 'refresh', _.bind(this.renderContent, this));
                    this.getRegion('priceRegion').show(this.pricesView);
          
                    this.printView = new PrintView({
                      model: this.model,
                      factorsV2: factorsV2,
                      currentPrices: currentPrices,
                      currentRsPrices: currentRsPrices,
                      prices: prices,
                      rsPrices: rsPrices,
                      product: this.model.get('product')
                    });
                    this.getRegion('printPriceRegion').show(this.printView);                    
                  }, this)).fail(_.bind(function(err) {
                    this.renderErrorAlert(err);
                  }, this));
                }, this)).fail(_.bind(function(err) {
                  this.renderErrorAlert(err);
                }, this));
              }, this)).fail(_.bind(function(err) {
                this.renderErrorAlert(err);
              }, this));
            }, this)).fail(_.bind(function(err) {
              this.renderErrorAlert(err);
            }, this));
          }, this)).fail(_.bind(function(err) {
          this.renderErrorAlert(err);
        }, this));
      }, this)).fail(_.bind(function(err) {
        this.renderErrorAlert(err);
      }, this));
    },

    renderLoading: function(show) {
      if (show) {
        this.ui.loading.show();
      } else {
        this.ui.loading.hide();
      }
    },

    renderErrorAlert: function (err) {
      if (err.status === 409) {
        bootbox.alert(_.i18n('orders.price.error.reset.validated'));
      } else {
        bootbox.alert('orders.price.error');
      }
      this.view.ui.blockLoading.hide();
    }
  });
});
